var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.79622V11.1296C0 12.2341 0.895431 13.1296 2 13.1296H8.66667C9.77124 13.1296 10.6667 12.2341 10.6667 11.1296V4.46289C10.6667 3.35832 9.77124 2.46289 8.66667 2.46289H0.666667C0.298477 2.46289 0 2.16441 0 1.79622ZM2.16667 6.46289C2.16667 6.18675 2.39052 5.96289 2.66667 5.96289H8C8.27614 5.96289 8.5 6.18675 8.5 6.46289C8.5 6.73903 8.27614 6.96289 8 6.96289H2.66667C2.39052 6.96289 2.16667 6.73903 2.16667 6.46289ZM2.16667 8.79622C2.16667 8.52008 2.39052 8.29622 2.66667 8.29622H6.33333C6.60948 8.29622 6.83333 8.52008 6.83333 8.79622C6.83333 9.07237 6.60948 9.29622 6.33333 9.29622H2.66667C2.39052 9.29622 2.16667 9.07237 2.16667 8.79622Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.272524 1.18762C0.504845 1.29181 0.666667 1.52512 0.666667 1.79622H8.66667C8.89687 1.79622 9.12025 1.82539 9.33333 1.88024V1.33358C9.33333 0.522185 8.61468 -0.101098 7.81144 0.0136512L0.613063 1.04199C0.484747 1.06032 0.368471 1.11205 0.272524 1.18762Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c802d183d4d679b9db3faf51e69e2710.svg";
export { ForwardRef as ReactComponent };